var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 33,
    height: 33
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 33,
    width: 33,
    height: 33,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 33 33)",
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.378 49.98l7.372-7.55a5.096 5.096 0 017.292 0l.08.082a5.226 5.226 0 010 7.303l-7.372 7.55a5.096 5.096 0 01-7.292 0l-.08-.083a5.226 5.226 0 010-7.302z",
    fillRule: "evenodd",
    fill: "#3B5998",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.048 42.43l7.292 7.467a5.344 5.344 0 010 7.467 5.096 5.096 0 01-7.292 0l-7.292-7.467a5.344 5.344 0 010-7.467 5.096 5.096 0 017.292 0z",
    fillRule: "evenodd",
    fill: "#307AF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.132 42.522l3.553 3.638-7.292 7.467-7.292-7.467 3.553-3.638a5.226 5.226 0 017.478 0z",
    fillRule: "evenodd",
    fill: "#0057FE"
  }))));
}

export default SvgLogo;